/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ScheduleCheckUsageGridDefinition } from './schedule-check-usage-grid-definition.service';
import { openInNewWindow } from '@gh/core-util';
import { replace } from 'lodash';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  standalone: false,
  selector: 'gh-schedule-check-usage-dialog',
  templateUrl: 'schedule-check-usage-dialog.component.html',
  styleUrls: ['schedule-check-usage-dialog.component.scss'],
  providers: [ScheduleCheckUsageGridDefinition],
})
export class ScheduleCheckUsageDialogComponent {
  input: any;

  constructor(public gridDefinition: ScheduleCheckUsageGridDefinition,
              private userContext: BuilderUserContext,
              private dialogRef: MatDialogRef<any>,
  ) {
  }

  onRowClick(event: any): void {
    if (event.data.scheduleLink) {
      openInNewWindow(replace(event.data.scheduleLink, '%BASE_URL%', this.userContext.baseUrl));
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
